import React from "react";
import PropTypes from "prop-types";
import "../../../styles/ComponentsStyles/Universal/StaffsHeadCard.style.css";

const StaffsHeadCard = ({ image, name, designation }) => {
    return <li className="staffHeadCardli">
        <img src={image} alt="" />
        <div className="profileDetails">
            <div>{name}</div>
            <div>{designation}</div>
        </div>
    </li>;
};

export default StaffsHeadCard
StaffsHeadCard.propTypes = {
    image: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    designation: PropTypes.string.isRequired,
};